// File: src/components/pictures/detail/PictureCommentAddReaction.js
import React, {useContext, useRef, useState} from 'react';
import UniversalEmojiMenu from 'components/universal/input/UniversalEmojiMenu';
import InputMoney from 'util/InputMoney';
import AddMoneyPopupWrapper from 'components/donate/AddMoneyPopupWrapper';
import itemTypeToEmoji from 'util/itemTypeToEmoji';
import {reactToCommentRequest} from 'util/api';
import {usePopup} from 'popup/PopupContext';
import {UserContext} from 'components/user/UserContext';

const defaultReactionCash = 15;

const PictureCommentAddReaction = ({comment}) => {
    const {user} = useContext(UserContext);

    const inputMoneyRef = useRef(null);
    const [isEmojiOpen, setIsEmojiOpen] = useState(false);
    const [reactionInputCash, setReactionInputCash] = useState(0);
    const emojiMenuRef = useRef(null);

    const {openPopup} = usePopup();

    const handleReactionInputCash = (cash) => {
        setReactionInputCash(cash);
    };

    const onEmojiOpenChange = (isOpen) => {
        if (isOpen) {
            setReactionInputCash(defaultReactionCash);
        } else {
            setReactionInputCash(0);
        }
        setIsEmojiOpen(isOpen);
    };

    const sendReaction = (emoji) => {
        if (Number(reactionInputCash) < 1) {
            return;
        }
        if (reactionInputCash > user.balance) {
            openPopup(<AddMoneyPopupWrapper initialAmount={reactionInputCash - user.balance}/>);
            if (emojiMenuRef.current) {
                emojiMenuRef.current.hideEmojiPopup();
            }
            return;
        }
        const nameOfEmoji = itemTypeToEmoji.getByCharacter(emoji);
        if (!nameOfEmoji) {
            console.error('Invalid emoji selected: ', emoji);
            return;
        }
        console.log('Sending reaction: ', nameOfEmoji, ' | ', reactionInputCash);
        reactToCommentRequest(comment.id, nameOfEmoji, reactionInputCash, user.balance).then(
            () => {
                if (emojiMenuRef.current) {
                    emojiMenuRef.current.hideEmojiPopup();
                }
            },
            (error) => {
                console.error('Failed to send reaction: ', error);
            }
        );
    };

    return (
        <div style={{display: 'flex', marginRight: '6px'}}>
            <UniversalEmojiMenu
                size="20px"
                isAddReaction={true}
                calmColor="#9c9c9c"
                activeColor="#5c5c5c"
                onKeyPress={sendReaction}
                ignoreClickRef={inputMoneyRef}
                onOpenedChange={onEmojiOpenChange}
                ref={emojiMenuRef}
            />
            {isEmojiOpen && (
                <div style={{paddingLeft: '6px'}}>
                    <InputMoney
                        ref={inputMoneyRef}
                        initialValue={defaultReactionCash}
                        onChange={handleReactionInputCash}
                    />
                </div>
            )}
        </div>
    );
};


export default PictureCommentAddReaction;